import React from 'react'

import PartyLozenge from '../../Helpers/PartyLozenge'
import RidingResult from '../../../models/RidingResult'
import Party from '../../../models/Party'
import U from '../../../utils/Utilities'
import { PartyResultCell } from '../Cells/PartyResultCell'

interface IProps {
  ridingResult: RidingResult
}

interface IState {
  isActive?: boolean
}

class RidingResultTableRow extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props)

    this.state = {
      isActive: false
    }

    this.toggleActive = this.toggleActive.bind(this)
  }

  protected toggleActive(): void {
    this.setState({
      isActive: !this.state.isActive
    })
  }

  public render(): JSX.Element {
    const { ridingResult } = this.props
    const riding = ridingResult.riding
    const winner = ridingResult.winner()
    const secondPlace = ridingResult.nthPlace(2)
    const margin = ridingResult.margin()
    const closeRace = ridingResult.closeRace()
    const lowThreshold = ridingResult.lowThreshold()

    const partyCells = Party.allPartiesArray().map(
      (party): JSX.Element => (
        <PartyResultCell
          className="d-none d-md-table-cell text-right"
          key={party.key}
          party={party}
          areaResult={ridingResult}
          accessor={(result): number => result.votePercent}
          formatter={U.formatPercent}
        />
      )
    )

    return (
      <tr key={riding.key} onClick={this.toggleActive}>
        <td>{riding.province.shortName}</td>
        {/* <td>{riding.key}</td> */}
        <td>{riding.name()}</td>
        {partyCells}
        <td className="text-center">
          <PartyLozenge party={winner.party} />
        </td>
        <td className={`text-right party-${winner.party.code}`}>
          {U.formatPercent(winner.votePercent)}
        </td>
        <td className="text-center">
          <PartyLozenge small muted party={secondPlace.party} />
        </td>

        <td className="text-right">+{U.formatPercent(margin)}</td>
        <td className="text-center text-muted">
          <i
            className={`fas fa-eye ${U.classIf(!closeRace, 'Hidden')}`}
            title="Close race"
          />
        </td>
        <td className="text-center text-muted">
          <i
            className={`fas fa-users ${U.classIf(!lowThreshold, 'Hidden')}`}
            title="Multi-way race"
          />
        </td>
      </tr>
    )
  }
}

export default RidingResultTableRow
